import { useEffect, useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { Crown, Loader2 } from "lucide-react";
import { api } from "@/lib/api";
import { useAuth } from "@/lib/auth";

export default function PaymentSuccess() {
  const nav = useNavigate();
  const [params] = useSearchParams();
  const { setUser } = useAuth();
  const [state, setState] = useState("checking");

  useEffect(() => {
    const sessionId = params.get("session_id");
    let tries = 0;
    let timer;
    const poll = async () => {
      try {
        const s = await api.paymentStatus(sessionId);
        if (s.payment_status === "paid") {
          setUser(await api.me());
          toast.success("Welcome to Pro. The full choir is yours.");
          return nav("/library", { replace: true });
        }
        if (["expired", "failed"].includes(s.payment_status)) return setState("failed");
      } catch {
        return setState("failed");
      }
      if (++tries >= 15) return setState("timeout");
      timer = setTimeout(poll, 2000);
    };
    poll();
    return () => clearTimeout(timer);
  }, [params, nav, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#080708] px-6" data-testid="payment-success-page">
      <div className="stone-panel arch-top p-10 text-center max-w-md">
        <Crown className="mx-auto text-[#D99B43]" size={32} />
        {state === "checking" ? (
          <p className="font-cormorant italic text-xl text-stone-300 mt-4 flex items-center gap-2 justify-center" data-testid="payment-status-checking">
            <Loader2 size={16} className="animate-spin" /> Confirming your subscription…
          </p>
        ) : (
          <>
            <p className="font-gothic uppercase tracking-wider text-stone-100 mt-4" data-testid="payment-status-error">
              {state === "timeout" ? "Still confirming" : "Payment not completed"}
            </p>
            <p className="text-sm text-stone-400 mt-2">
              {state === "timeout" ? "Stripe is taking a moment. Refresh this page shortly." : "No charge was made. You can try again."}
            </p>
            <Link to="/checkout" className="btn-gothic mt-6 inline-flex">Back to checkout</Link>
          </>
        )}
      </div>
    </div>
  );
}
